<template>
    <div>
        <div class="assess-complain-wrapper cfx" >
            <div class="assess-complain-title" >
                <div class="assess-complain-title-info" >
                    <img :src="headPicUrl">
                    <div class="assess-complain-name" >
                        <p>{{appealObject.studentName}}</p>
                        <span>({{appealObject.className}})</span>
                    </div>
                </div>
                <div class="assess-complain-score green" v-if="appealObject.type == 2" >已处理</div>
                <div class="assess-complain-score orange" v-else >未处理</div>
            </div>
            <div class="assess-complain-content" >
                <div class="assess-complain-content-item" >
                    <label>学年</label>
                    <div style="width:100%; float:left;" >
                        <p>{{Number(appealObject.schoolYear)}}-{{Number(appealObject.schoolYear) + 1}}</p>
                    </div>
                </div>
                <div class="assess-complain-content-item" >
                    <label>学期</label>
                    <div style="width:100%; float:left;" >
                        <p>{{appealObject.eduPeriod == 1 ? '第一学期' : '第二学期'}}</p>
                    </div>
                </div>
                <div class="assess-complain-content-item" >
                    <label>时间</label>
                    <div style="width:100%; float:left;" >
                        <p>{{appealObject.time}}</p>
                    </div>
                </div>
                <div class="assess-complain-content-item" >
                    <label>模块类型</label>
                    <div style="width:100%; float:left;" >
                        <p>{{appealObject.parTitle}}</p>
                    </div>
                </div>
                <div class="assess-complain-content-item" >
                    <label>模块子类</label>
                    <div style="width:100%; float:left;" >
                        <p>{{appealObject.chaTitle}}</p>
                    </div>
                </div>
                <div class="assess-complain-content-item" >
                    <label>事实依据</label>
                    <div style="width:100%; float:left;" >
                        <p>{{appealObject.factTitle}}</p>
                    </div>
                </div>
                <div class="assess-complain-content-item" >
                    <label>备注</label>
                    <div style="width:100%; float:left;" >
                        <p>{{appealObject.content}}</p>
                    </div>
                </div>
                <div class="assess-complain-content-item" >
                    <label>附件</label>
                    <div style="width:100%; float:left;" >
                        <p><i class="iconfont icon-fujian" ></i>{{appealObject.docName}}</p>
                    </div>
                </div>
            </div>
            <div class="assess-student-appeal-text" >
                <span>申诉内容：</span>
                <p>{{appealObject.appealText}}</p>
            </div>
        </div>
        <div class="assess-student-msg-apply" >
            <p class="assess-student-msg-apply-num" >回复{{msgList.length}}</p>
            <div class="assess-student-msg-apply-item" v-for="(msg,index) in msgList" :key="index">
                <img :src="headPicUrl">
                <div class="assess-student-msg-apply-text" >
                    <h4>{{msg.userName}}（{{msg.jobName == 'undefined' ? '教师' :msg.jobName}}）</h4>
                    <span>{{msg.makeTime}}</span>
                    <p>{{msg.content}}</p>
                </div>
            </div>
        </div>
        <div class="comment-box-wrapper" v-show="isShowBox" >
            <div class="comment-box" >
                <span class="review" >回复：</span>
                <input type="text" class="input-box" @blur="focusState = false"  v-focus="focusState" v-model.trim="message" >
                <button class="btn-submint" @click="textSubmit" >提交</button>
            </div>
        </div>
        <div v-if="this.userInfo.userType == '3' && msgList.length == 0" ></div>
        <div class="assess-student-msg-apply-btn" v-else-if="this.userInfo.userType == '3'" >
            <button @click="msgApply" v-show="isShowBtn" >回复</button>
        </div>
        <div v-else >
            <div class="assess-student-msg-edit-btn" v-show="isShowBtn">
                <button class="orange" @click="editComment(appealObject.id)" >修改评价</button>
                <button @click="msgApply" >回复</button>
                <button @click="deleteComment(appealObject.id)" >删除评价</button>
            </div>
            <div class="assess-student-msg-edit-btn" v-show="hasDealed" >
                <button class="btn-only-one" @click="msgApply" >回复</button>
            </div>
        </div>
        <!-- 底部返回上一页 返回首页信息放这里 -->
        <bottom></bottom>
    </div>
</template>
<script>
import default_avatar from '@/assets/images/user.png?20241114'
import { getUserInfo } from '../../service/user-service.js'
import Bottom from '../bottom.vue'
import { MessageBox } from 'mint-ui';
import { Toast } from 'mint-ui';
export default {
    data() {
        return {
            headPicUrl: default_avatar,
            timeInfo: {},
            userInfo: {},
            id: this.$route.query.id,
            appealId: this.$route.query.appealId,
            userId: this.$route.query.userId,
            appealObject: {},               //申诉详情对象
            msgList: [],                    //留言数组
            isShowBox: false,
            isShowBtn: true,
            focusState: false,              //点击回复按钮，光标自动聚焦
            message: '',                    //留言内容
            hasDealed: false
        }
    },
    components: { Bottom },
    mounted () {
        this.$nextTick( () => {
            getUserInfo().then((user) => {
                this.timeInfo = user.nowYearAndTermAndMonth;
                this.userInfo = user.user;
                this.getAppealDetail();
            });
        });
    },
    methods: {
        //获取申诉详情
        getAppealDetail() {
            this.$http.get('/api/mobile/devel/comment/getAppealDetail', {
                params: {
                    id: this.id,
                    userId: this.userId,
                    thisUserId: this.userInfo.userId
                }
            }).then(res => {
                if(res.data.code == 0) {
                    this.appealObject = res.data.data
                    this.msgList = res.data.appealList;
                    if(this.appealObject.validFlag != 'Y') {
                        this.isShowBtn = false;
                        this.hasDealed = true;
                    }
                }
            })
        },
        //申诉回复(首次)
        getFirstApplyData() {
            this.$http.get('/api/mobile/devel/comment/updateAppeal', {
                params: {
                    appealId: this.appealId,
                    textUser: this.userInfo.userId,
                    type: 2,
                    textReply: this.message
                }
            }).then(res => {
                if(res.data.code == 0) {
                    this.isShowBox = false;
                    this.isShowBtn = true;
                    this.message = '';
                    this.getAppealDetail();
                }
            })
        },
        // 申诉回复（非首次）
        getApplyData() {
            this.$http.get('/api/mobile/devel/comment/addAppeal', {
                params: {
                    appealId: this.appealId,
                    content: this.message,
                    userId: this.userInfo.userId,
                    toUser: ''
                }
            }).then(res => {
                if(res.data.code == 0) {
                    this.isShowBox = false;
                    this.isShowBtn = true;
                    this.message = '';
                    this.getAppealDetail();
                }
            })
        },
        msgApply() {
            this.isShowBtn = false;
            this.isShowBox = true;
            this.focusState = true;
        },
        textSubmit() {
            if(this.message == '') {
                Toast('回复内容不能为空！');
                return;
            }
            if(!this.msgList.length){
                this.getFirstApplyData();
            } else {
                this.getApplyData();
            }
        },
        // 修改评价
        editComment(id,appealId) {
            this.$router.push({
                name: 'Assess-teacher-class-add',
                query: {id:id, appealId: this.$route.query.appealId}
            })
        },
        // 删除评价
        deleteComment(id) {
            MessageBox.confirm('确定删除评价？').then(res => {
                this.$http.get('/api/mobile/devel/comment/delete', {
                    params: {
                        id: id
                    }
                }).then(res => {
                    if(res.data.code == 0) {
                        this.getAppealDetail();
                        Toast(res.data.message);
                    }
                }).catch(() => {
                    Toast(res.data.message);
                    return;
                })
            })
        }
    },
    directives: {
        focus: {
            update: function (el, value) {    //第二个参数传进来的是个json
                if (value) {
                    el.focus();
                }
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/assessment/assess-student-appeal-detail.vue